module.exports = __webpack_public_path__ + "img/analisis_tarifas.89baabca.svg";